import templateUrl from './sgi-id-assignment-report.component.html'
import { EditSgiIdAssignmentModal } from "../edit-sgi-id-assignment/edit-sgi-id-assignment-modal.component";

export const SgiIdAssignmentReportComponent = {
    templateUrl,
    controller: class SgiIdAssignmentReport {
        constructor($uibModal, apexApiUrl, onboardingApplicationService, utilityService) {
            'ngInject'
            this.apexApiUrl = apexApiUrl;
            this.$uibModal = $uibModal
            this.onboardingApplicationService = onboardingApplicationService
            this.utilityService = utilityService

            this.pageNumber = 1
            this.pageSize = 25
        }

        $onInit() {
            const loading = this.loadSgiIdReportPage()
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Initial load failed")
            )
        }

        onChangeFilters() {
            this.pageNumber = 1
            const loading = this.loadSgiIdReportPage()
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Reloading data failed")
            )
        }

        onChangePage() {
            const loading = this.loadSgiIdReportPage()
            this.utilityService.showLoadingUntilResolved(
                this.utilityService.alertOnError(loading, "Changing page failed")
            )
        }

        onExportSgiIdReport() {
            window.location.href = this.apexApiUrl + "/sgi-id-report.csv";
        }

        /**
         * Open an editor for editing an SGI ID's assignment history.
         * @param {any} assignment The assignment record to be edited.
         */
        onEditSgiIdAssignment(assignment) {
            // Defer editor logic to the SGI ID Assignment editor.
            const sgiAssignmentHistories = this.onboardingApplicationService.retrieveEmployeeSgiIdHistory(
                assignment.IcdOffice.Id, assignment.EmployeeID)
            this.$uibModal.open({
                ...EditSgiIdAssignmentModal,
                resolve: {
                    onboardingApplication: () => assignment,
                    sgiAssignmentHistories: () => sgiAssignmentHistories,
                    isAdminView: () => true
                }
            });
            this.utilityService.showLoadingUntilResolved(sgiAssignmentHistories)
        }

        loadSgiIdReportPage() {
            return this.onboardingApplicationService.retrieveSgiIdReport({
                pageIndex: this.pageNumber - 1,
                pageSize: this.pageSize,
                searchField: this.sgiIdReportSearch
            })
                .then(page => {
                    this.page = page
                    this.sgiIdReport = page.Entities
                });
        }
    }
}
